import { render, staticRenderFns } from "./SearchDocumentSection.vue?vue&type=template&id=d1c7224a"
import script from "./SearchDocumentSection.vue?vue&type=script&lang=js"
export * from "./SearchDocumentSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports